import cn from "classnames";

import { useStore } from "@hooks/useZustandProvider";

// import { useMousePosition } from "@hooks/useMousePosition";
import s from "./Container.module.scss";

const Container = ({
  className,
  children,
  full = true,
  cursorNotice,
  collectionType,
  withoutBubbling = true,
  fullMobile = false,
  fullTablet = false,
  fullLaptop = false,
  ...props
}) => {
  // const { isWidget } = useMousePosition();
  const { cms, updateModals, updateBlockIndex } = useStore();
  const { isWidget } = cms.page;
  const { isEditMode } = cms.uiOptions;
  const { isWidgetEditing } = cms.widget;

  const handleClick = (e) => {
    // TODO: this code must be common for all cases
    const blockIndex =
      e.target.closest("[data-block-index]")?.dataset?.blockIndex;

    Number.isInteger(Number(blockIndex)) &&
      updateBlockIndex(Number(blockIndex));

    if (e.currentTarget != e.target) return;

    switch (e.detail) {
      case 1: // click
        break;
      case 2: // double click
        updateModals({
          isOpenUploadImagesModal: true,
        });
        break;
      case 3: // triple click
        break;
    }
  };

  return (
    <div
      {...(isEditMode && cursorNotice && !(!isWidgetEditing && isWidget)
        ? {
            "data-cursor-notice": cursorNotice,
            "data-collection-type": collectionType,
            "data-withoutbubbling": withoutBubbling,
            onClick: handleClick,
          }
        : {})}
      className={cn(
        s.container,
        full && s.full,
        fullMobile && s.fullMobile,
        fullTablet && s.fullTablet,
        fullLaptop && s.fullLaptop,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default Container;
